
import {Issuer} from "@/model/Issuer";
import Vue, {PropType} from "vue";
import InformationDialog from "@/components/base/InformationDialog.vue";
import LogoEdit from "@/components/LogoEdit.vue";
import FloatingActionButton from "@/components/buttons/FloatingActionButton.vue";

export default Vue.extend({
  components: {LogoEdit, InformationDialog, FloatingActionButton},
  props: {
    label: String,
    model: {
      required: true,
      type: Object as PropType<Issuer>
    },
    isdummy: Boolean,
    HasNoEditRights: Boolean,
    expanded: {
      required: false,
      type: Array as PropType<Array<number>>,
      default() {
        return [1]
      }
    },
  },
  data: function () {
    return {
      valid: true,
      maximumImageWidth: 1920,
      maximumImageHeight: 1280,
      dpi: 300,
      internalExpand: [1]
    };
  },
  mounted() {
    this.internalExpand = this.expanded;
  },
  computed: {
    maxCardNumber(): number {
      return parseInt(this.$config.CardNumberRange.MaximumCardNumber);
    },
    minCardNumber(): number {
      return parseInt(this.$config.CardNumberRange.MinimumCardNumber);
    },
    rules() {
      return {
         isNumeric: (value: string | undefined) =>
            !value ||
            !Number.isNaN(Number(value)) ||
            this.$t("Rules.NotANumber"),
        checkCardNumber: (choosenCardNumber: string | undefined): any =>
            !choosenCardNumber ||
            this.hasValidCardRange(choosenCardNumber) ||
            this.$t("Rules.CardNumberNotAllowed", {minNumber: this.minCardNumber, maxNumber: this.maxCardNumber})
      };
    },
  },
  methods: {
    hasValidCardRange(value: string) {
      if(Number.isNaN(Number(value)))
        return false

      let cardNumber = Number.parseInt(value, 10)
      return this.minCardNumber <= cardNumber && cardNumber <= this.maxCardNumber
    },
  },
  watch: {
    valid: function (value) {
      this.$emit("ValidChanged", value);
    },
    expanded: function (value){
      this.internalExpand = value;
    }
  },
});
